module.exports = __webpack_public_path__ + "img/Gallery_2_33.f8de8fcc.jpeg";